import React from 'react';
import WebOrder from './WebOrder';
 
export default (props) => <WebOrder {...props}/>;

